import { render, staticRenderFns } from "./ShopTab.vue?vue&type=template&id=59f27610&scoped=true"
import script from "./ShopTab.vue?vue&type=script&lang=js"
export * from "./ShopTab.vue?vue&type=script&lang=js"
import style0 from "./ShopTab.vue?vue&type=style&index=0&id=59f27610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f27610",
  null
  
)

export default component.exports